import React, { Component } from "react";
import "antd/dist/antd.css";
import {

    jobQuestionList,

} from "../../action/jobs";
import {
    onChange,
    setIsRequired,
    validateForm,
} from "../../utils";
import moment from "moment";
import NumberFormat from "react-number-format";
import { Select } from "antd";
import Multiselect from "multiselect-react-dropdown";

export default class PostAJob extends Component {
    constructor(props) {
        super(props);
        const detail = this.props.Data;
        this.state = {
            INCLUDE_WALK_IN_DISTANCE: false,
            WALK_IN_START_DATE: {
                name: "WALK_IN_START_DATE",
                value: detail ? detail.WALK_IN_START_DATE : "",
                options: [],
                error: "",
                isRequired: false,
            },
            WALK_IN_START_TIME: {
                name: "WALK_IN_START_TIME",
                value: detail ? detail.WALK_IN_START_TIME : "",
                options: [],
                error: "",
                isRequired: false,
            },
            WALK_IN_END_TIME: {
                name: "WALK_IN_END_TIME",
                value: detail ? detail.WALK_IN_END_TIME : "",
                options: [],
                error: "",
                isRequired: false,
            },
            DURATION: {
                name: "DURATION",
                value: detail ? detail.DURATION : "",
                options: [],
                error: "",
                isRequired: false,
            },
            CONTACT_PERSON: {
                name: "CONTACT_PERSON",
                value: detail ? detail.CONTACT_PERSON : "",
                options: [],
                error: "",
                isRequired: false,
            },
            MOBILE_NUMBER: {
                name: "MOBILE_NUMBER",
                value: detail ? detail.MOBILE_NUMBER : "",
                options: [],
                error: "",
                isRequired: false,
            },
            VENUE: {
                name: "VENUE",
                value: detail ? detail.VENUE : "",
                options: [],
                error: "",
                isRequired: false,
            },
            GOOGLE_MAP_URL: {
                name: "GOOGLE_MAP_URL",
                value: detail ? detail.GOOGLE_MAP_URL : "",
                options: [],
                error: "",
                isRequired: false,
            },
            COMPANY_NAME: {
                name: "COMPANY_NAME",
                value: detail ? detail.COMPANY_NAME : "",
                options: [],
                error: "",
                isRequired: false,
            },
            SELECTED_QUESTIONS: detail ? detail.QUESTION_ID.map((data, index) => {
                return {
                    QUESTION_ID: data.QUESTION_ID,
                    QUESTION: data.QUESTION,
                    label: data.QUESTION
                }
            }) : [],
            QuestionList: []
        };
    }
    componentDidMount() {
    }



    getJobQuestion = (input) => {
        jobQuestionList(input).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        QUESTION_ID: data.QUESTION_ID,
                        QUESTION: data.QUESTION,
                        label: data.QUESTION
                    }
                })
                this.setState({
                    QuestionList: d || [],
                    searchKey: true
                })
            }
        });

    }
    onChange = (e) => {
        const { name, value } = e.target;

        onChange(this, name, value);
    };

    handleCheckBox = (e) => {
        const { DURATION, WALK_IN_START_DATE, VENUE } = this.state;
        const isWalkIn = e.target.value === "in_person";
    
        // Update state to reflect the selected option
        this.setState({ INCLUDE_WALK_IN_DISTANCE: isWalkIn });
    
        // Set required fields based on the selection
        setIsRequired(this, WALK_IN_START_DATE.name, isWalkIn);
        setIsRequired(this, VENUE.name, isWalkIn);
        setIsRequired(this, DURATION.name, isWalkIn);
    };
    

    onSubmit = (e) => {
        debugger
        e.preventDefault();

        if (validateForm(this)) {
            const {
                INCLUDE_WALK_IN_DISTANCE,
                WALK_IN_START_DATE,
                WALK_IN_START_TIME,
                WALK_IN_END_TIME,
                DURATION,
                CONTACT_PERSON,
                MOBILE_NUMBER,
                VENUE,
                GOOGLE_MAP_URL,
                SELECTED_QUESTIONS,
            } = this.state;

            const model = {
                IS_INCLUDE_WALK_IN: INCLUDE_WALK_IN_DISTANCE ? "Y" : "N",
                WALK_IN_START_DATE: INCLUDE_WALK_IN_DISTANCE ? WALK_IN_START_DATE.value : "",
                DURATION: INCLUDE_WALK_IN_DISTANCE ? DURATION.value : "",
                WALK_IN_START_TIME: INCLUDE_WALK_IN_DISTANCE ? WALK_IN_START_TIME.value : "",
                WALK_IN_END_TIME: INCLUDE_WALK_IN_DISTANCE ? WALK_IN_END_TIME.value : "",
                CONTACT_PERSON: INCLUDE_WALK_IN_DISTANCE ? CONTACT_PERSON.value : "",
                MOBILE_NUMBER: INCLUDE_WALK_IN_DISTANCE ? MOBILE_NUMBER.value : "",
                VENUE: INCLUDE_WALK_IN_DISTANCE ? VENUE.value : "",
                GOOGLE_MAP_URL: INCLUDE_WALK_IN_DISTANCE ? GOOGLE_MAP_URL.value : "",
                QUESTIONS: SELECTED_QUESTIONS,
            };
            this.props.onSubmit(model);
        }
    };

    onShowModal = () => {
        this.setState({ showModal: true });
    };

    onhideModal = () => {
        this.setState({ showModal: false });
    };

    render() {
        const {
            INCLUDE_WALK_IN_DISTANCE,
            WALK_IN_START_DATE,
            WALK_IN_START_TIME,
            WALK_IN_END_TIME,
            DURATION,
            CONTACT_PERSON,
            MOBILE_NUMBER,
            VENUE,
            GOOGLE_MAP_URL,
            SELECTED_QUESTIONS,
        } = this.state;


        return (
            <React.Fragment>
                <section className="pricing-area padding-bottom-80px">
                    <div className="container">
                        <div className="row mt-2">
                            <div className="col-lg-12">
                                <div className="billing-form-item mb-0">
                                    <div className="billing-title-wrap">
                                        <h3 className="widget-title pb-0">Interview details</h3>

                                        <div className="title-shape margin-top-5px"></div>
                                    </div>
                                    <form onSubmit={(e) => this.onSubmit(e)}>

                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">
                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">Let candidates know how interview will be conducted for this job.</span>
                                                    </div>


                                                    <div className="col-lg-12 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text pb-1">
                                                                Type of Interview {' '}
                                                                <span className="text-danger font-size-16">*</span>
                                                            </label>
                                                            <div className="wfhduring">
                                                                <ul>
                                                                    <li>
                                                                        <input
                                                                            type="radio"
                                                                            name="INCLUDE_WALK_IN_DISTANCE"
                                                                            value="in_person"
                                                                            checked={INCLUDE_WALK_IN_DISTANCE}
                                                                            onChange={this.handleCheckBox}
                                                                        />
                                                                        <div className="wfhheading">
                                                                            In-Person / Walk-In Interview
                                                                            <p>This job is for fresher candidates only.</p>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <input
                                                                            type="radio"
                                                                            name="INCLUDE_WALK_IN_DISTANCE"
                                                                            value="online"
                                                                            checked={!INCLUDE_WALK_IN_DISTANCE}
                                                                            onChange={this.handleCheckBox}
                                                                        />
                                                                        <div className="wfhheading">
                                                                            Telephonic/Online Interview
                                                                            <p>This job is for experienced candidates only.</p>
                                                                        </div>
                                                                    </li>
                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {INCLUDE_WALK_IN_DISTANCE &&
                                                        <div className="col-lg-12 column-lg-full pt-2">
                                                            <div className="row">
                                                                <div className="col-lg-4">
                                                                    <label className="label-text">
                                                                        Walk-in Start Date{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                WALK_IN_START_DATE.error.length >
                                                                                    0
                                                                                    ? "form-control is-invalid"
                                                                                    : "form-control"
                                                                            }
                                                                            type="date"
                                                                            placeholder="Choose start date"
                                                                            name={WALK_IN_START_DATE.name}
                                                                            value={WALK_IN_START_DATE.value}
                                                                            onChange={this.onChange}
                                                                            min={moment().format("YYYY-MM-DD")}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-4">
                                                                    <label className="label-text">
                                                                        Walk-in start timing
                                                                    </label>
                                                                    <div className="form-group ">
                                                                        <input
                                                                            className="form-control"
                                                                            type="time"
                                                                            placeholder="Choose start date"
                                                                            name={WALK_IN_START_TIME.name}
                                                                            value={WALK_IN_START_TIME.value}
                                                                            onChange={this.onChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <label className="label-text">
                                                                        Walk-in end timing
                                                                    </label>
                                                                    <div className="form-group ">
                                                                        <input
                                                                            className="form-control"
                                                                            type="time"
                                                                            placeholder="Choose start date"
                                                                            name={WALK_IN_END_TIME.name}
                                                                            value={WALK_IN_END_TIME.value}
                                                                            onChange={this.onChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <label className="label-text">
                                                                        Duration (Days){" "}
                                                                        <span className="text-danger">*</span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <NumberFormat
                                                                            className={
                                                                                DURATION.error.length > 0
                                                                                    ? "form-control is-invalid"
                                                                                    : "form-control"
                                                                            }
                                                                            placeholder="Duration in days"
                                                                            name={DURATION.name}
                                                                            value={DURATION.value}
                                                                            onChange={this.onChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Contact Person
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <input
                                                                                className="form-control"
                                                                                type="text"
                                                                                name={CONTACT_PERSON.name}
                                                                                value={CONTACT_PERSON.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Recruiter name(if available)"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Contact Number
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <NumberFormat
                                                                                className="form-control"
                                                                                name={MOBILE_NUMBER.name}
                                                                                value={MOBILE_NUMBER.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Add mobile number"
                                                                                maxLength={10}
                                                                                minLength={10}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Venue{" "}
                                                                            <span className="text-danger">
                                                                                *
                                                                            </span>
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <input
                                                                                className={
                                                                                    VENUE.error.length > 0
                                                                                        ? "form-control is-invalid"
                                                                                        : "form-control"
                                                                                }
                                                                                type="text"
                                                                                name={VENUE.name}
                                                                                value={VENUE.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Type Address Here"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Google Map URL
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <input
                                                                                className="form-control"
                                                                                type="text"
                                                                                // name={GOOGLE_MAP_URL.name}
                                                                                // value={GOOGLE_MAP_URL.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Google Map URL of venue"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }




                                                    <div className="col-lg-12 column-lg-full pt-3">
                                                        <div className="recruiterAskQ">
                                                            <div className="askquetext">
                                                                <h6>
                                                                    Ask questions to candidates they should
                                                                    respond to when they are applying
                                                                </h6>
                                                                <p>
                                                                    Here are a few suggestions to get you
                                                                    started
                                                                </p>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-lg-12 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Add Questions
                                                                        </label>



                                                                        <div className="form-group">

                                                                            <Multiselect
                                                                                placeholder='Select Question'
                                                                                style={{
                                                                                    optionContainer:
                                                                                        this.state.searchKey ? { display: 'block' } : { display: 'none' }
                                                                                }}
                                                                                options={this.state.QuestionList}

                                                                                onSelect={(selectedValue) => {

                                                                                    this.setState({ SELECTED_QUESTIONS: selectedValue })
                                                                                }}
                                                                                onSearch={(e) => {
                                                                                    this.getJobQuestion(e)
                                                                                }
                                                                                }
                                                                                selectedValues={SELECTED_QUESTIONS}
                                                                                displayValue={"QUESTION"}
                                                                                name={"QUESTION_ID"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>



                                                </div>

                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="btn-box">
                                                        <button
                                                            type="button"
                                                            className="theme-btn border-0"
                                                            onClick={() => { this.props.prevStep() }}
                                                        >
                                                            Previous
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 text-right">
                                                    <div className="btn-box">
                                                        <button
                                                            type="submit"
                                                            className="theme-btn border-0"
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </form>


                                </div>
                            </div>

                        </div>

                    </div>
                </section>



            </React.Fragment >
        );
    }

}
